<div class="flex flex-wrap justify-start lg:justify-end gap-4">
  <button
    class="py-1 px-5 border border-[#d9d9d9] rounded"
    (click)="onGroupDiscardClick()"
    [disabled]="selectedFiling.length < 2"
    [ngClass]="{
      'bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]':
        selectedFiling.length >= 2,
      'bg-white text-gray-800 cursor-not-allowed': selectedFiling.length < 2
    }"
    pTooltip="{{
      selectedFiling.length < 2
        ? 'Select at least two rows to enable grouping'
        : ''
    }}"
    tooltipPosition="top"
  >
    Group Discard
  </button>
  <p-datepicker
    [(ngModel)]="rangeDates"
    selectionMode="range"
    clearButtonStyleClass="bg-red right-4 ml-6 text-red"
    [inputStyle]="{
      border: 'none',
      paddingLeft: '0',
      paddingRight: '0'
    }"
    [styleClass]="
      'peer block px-0 pr-10 w-full text-sm text-gray-900  appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 border-gray-300 focus:border-[#1f273b]'
    "
    (onSelect)="onDateChange()"
    (onClear)="onDateChange()"
    placeholder="Search by date"
    showClear="true"
  ></p-datepicker>

<div class="relative w-full mt-3 sm:w-auto">
  <input
    type="text"
    name="filingId"
    placeholder="Search by filing Id"
    [(ngModel)]="filingIdInput"
    #filingIdCtrl="ngModel"
    pattern="^[0-9]*$"
    inputmode="numeric"
    (keydown)="preventSpaceKey($event)"
    (keydown.enter)="onSearch()"
    class="border-b text-sm border-gray-400 focus:outline-none
           focus:border-[#001529] px-1 py-1 placeholder-gray-400"
  />

  <span
    *ngIf="filingIdCtrl.invalid && (filingIdCtrl.dirty || filingIdCtrl.touched)"
    class="
      absolute left-0 top-full mt-1
      text-red-600 text-xs
      z-50
      max-w-[220px]
      break-words
      leading-tight
    "
  >
    Filing ID must be an integer.
  </span>
</div>


  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerNameInput"
    class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
    placeholder="Search by issuer name"
    type="text"
  />

  <select
    (change)="onSearch()"
    [(ngModel)]="selectedFormType"
    class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
  >
    <option [ngValue]="null">Select form type</option>
    <option *ngFor="let type of formTypes" [ngValue]="type">
      {{ type }}
    </option>
  </select>
</div>
<div class="mb-4"></div>
<p-table
  [tableStyle]="{ 'min-width': '50rem' }"
  [value]="filingRecords"
  [paginator]="true"
  [first]="first"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [(selection)]="selectedFiling"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th style="width: 4rem">
        <p-tableHeaderCheckbox />
      </th>
      <th>Filing ID</th>
      <th>Company Name</th>
      <th>Filing Date</th>
      <th>Accession Number</th>
      <th>Form Type</th>
      <th>Error Type</th>
      <th>FormLink</th>
      <th>Current Text</th>
      <th>Update Text</th>
      <th>Discard</th>
    </tr>
  </ng-template>
  <ng-template #body let-filingRecord>
    <tr>
      <td>
        <p-tableCheckbox [value]="filingRecord" />
      </td>
      <td>
        <a
          *ngIf="filingRecord.filingId; else empty"
          [href]="
            '/inbox?filingId=' +
            filingRecord.filingId +
            '&filingState=' +
            filingRecord.filingState
          "
          [style.color]="'#4a90e2'"
          [style.cursor]="'pointer'"
          [style.text-decoration]="'underline'"
          rel="noopener"
          target="_blank"
          >{{ filingRecord.filingId }}</a
        >

        <ng-template #empty>
          <span>-</span>
        </ng-template>
      </td>
      <td>{{ filingRecord.companyName }}</td>
      <td class="whitespace-nowrap">{{ filingRecord.filingDate }}</td>
      <td>{{ filingRecord.accessionNumber }}</td>
      <td>{{ filingRecord.filingType }}</td>
      <td
        style="
          max-width: 250px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        "
        [pTooltip]="filingRecord.errorType"
        tooltipPosition="top"
      >
        {{ filingRecord.errorType }}
      </td>
      <!-- <td>{{ filingRecord.errorType }}</td> -->
      <td><a href="{{ filingRecord.xbUrl }}" target="_blank">Link</a></td>
      <td
        style="
          max-width: 250px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        "
      >
        <span
          [pTooltip]="filingRecord.requiredSectionText"
          tooltipPosition="top"
          [tooltipStyleClass]="'custom-tooltip'"
          [autoHide]="false"
          [tooltipDisabled]="!filingRecord.requiredSectionText"
          class="block overflow-hidden text-ellipsis whitespace-nowrap"
        >
          {{ filingRecord.requiredSectionText }}
        </span>
      </td>

      <!-- <td [pTooltip]="filingRecord.requiredSectionText">
        {{
          filingRecord.requiredSectionText
            ?.toString()
            .substring(0, maxCharToShow) || "N/A"
        }}
      </td> -->
      <!-- <td>
        <p-button
          type="button"
          (onClick)="showModal(filingRecord)"
          class="p-button-text whitespace-nowrap"
          label="Update Text"
        ></p-button>
      </td> -->
      <td>
        <button
          class="row-action-button"
          (click)="showModal(filingRecord)"
          pTooltip="Update text"
          tooltipPosition="top"
          [disabled]="shouldDisableRowAction(filingRecord)"
        >
          <i class="pi pi-pencil"></i>
        </button>
      </td>

      <td>
        <button
          class="row-action-button danger"
          (click)="discardFiling(filingRecord)"
          pTooltip="Discard filing"
          tooltipPosition="top"
          [disabled]="shouldDisableRowAction(filingRecord)"
        >
          <i class="pi pi-trash"></i>
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="isDialogVisible"
  [closable]="true"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '60vw', }"
  [baseZIndex]="10000"
  header="Update Text Section"
  [maximizable]="true"
>
  <!-- Wrapper with fixed height -->
  <div class="flex flex-col h-full space-y-4">
    <!-- Issue Type -->
    <!-- Issue Type -->
    <div class="flex items-start gap-4 mb-4 flex-wrap md:flex-nowrap">
      <!-- Label with required asterisk -->
      <label
        for="issuer"
        class="min-w-[120px] text-base font-semibold text-gray-800 flex items-center"
      >
        Issue Type: <span class="text-red-500 ml-1">*</span>
      </label>

      <!-- Dropdown and error message -->
      <div class="flex flex-col w-full md:w-auto">
        <p-dropdown
          [(ngModel)]="selectedIssueType"
          [options]="issueTypes"
          inputId="issuer"
          placeholder="Select Issue Type"
          class="min-w-[200px] w-full shadow-sm"
          [ngClass]="{
            'p-invalid border border-red-500':
              showValidationError && !selectedIssueType
          }"
        ></p-dropdown>

        <small
          *ngIf="showValidationError && !selectedIssueType"
          class="text-red-500 mt-1"
        >
          Issue Type is required.
        </small>
      </div>
    </div>

    <div
      class="flex items-center gap-2 text-lg font-semibold text-gray-800 border-b pb-1 mb-2"
    >
      <i class="pi pi-align-left text-primary"></i>
      <span>Text Section</span>
    </div>
    <!-- Scrollable TextArea -->
    <div class="flex-1 overflow-y-auto">
      <p-floatLabel>
        <textarea
          [(ngModel)]="selectedFilingRecord.requiredSectionText"
          pTextarea
          id="textSection"
          rows="20"
          class="w-full"
        ></textarea>
      </p-floatLabel>
    </div>

    <!-- Save Button (Sticky Bottom) -->
    <div class="flex justify-end">
      <p-button
        label="Save"
        [disabled]="
          (selectedFilingRecord.requiredSectionText?.length || 0) < 1 ||
          isSaveLoading
        "
        [loading]="isSaveLoading"
        (onClick)="saveTheText()"
        iconPos="left"
      ></p-button>
    </div>
  </div>
</p-dialog>

<p-toast key="message" position="center"></p-toast>
